import React from "react";
import { Group, SegmentedControl, Select } from "@mantine/core";
import { useTranslation } from "react-i18next";

/**
 * MyCollectionToolbar 컴포넌트
 * 
 * Props:
 * @param {string} aggregationType - 집계 방식 값 [Required] ('total' | 'average')
 * @param {function} onAggregationChange - 집계 방식 변경 핸들러 [Required]
 * @param {string} sortMetric - 정렬 기준 값 [Required] ('views' | 'likes' | 'replies' | 'reposts')
 * @param {function} onSortChange - 정렬 기준 변경 핸들러 [Required]
 *
 * Example usage:
 * <MyCollectionToolbar
 *   aggregationType={aggregationType}
 *   onAggregationChange={setAggregationType}
 *   sortMetric={sortMetric}
 *   onSortChange={setSortMetric}
 * />
 */
function MyCollectionToolbar({ aggregationType, onAggregationChange, sortMetric, onSortChange }) {
  const { t } = useTranslation();

  return (
    <Group position="apart" align="center" wrap="wrap" gap="sm">
      <SegmentedControl
        value={aggregationType}
        onChange={onAggregationChange}
        size="lg"
        data={[
          { label: t("common.total"), value: "total" },
          { label: t("common.average"), value: "average" },
        ]}
      />
      <Select
        value={sortMetric}
        onChange={onSortChange}
        data={[
          { label: t("common.views"), value: "views" },
          { label: t("common.likes"), value: "likes" },
          { label: t("common.replies"), value: "replies" },
          { label: t("common.reposts"), value: "reposts" },
        ]}
        placeholder={t("myCollection.sortBy.placeholder")}
        style={{ width: 150 }}
      />
    </Group>
  );
}

export default MyCollectionToolbar;


